import { createReducer } from 'redux-act';
import * as actions from '#app/actions/maintenance';

export interface MaintenanceState {
  maintenanceMode: boolean;
}

const initialState: MaintenanceState = {
  maintenanceMode: false,
};

export default createReducer<MaintenanceState>(
  {
    [actions.maintenanceDetected as any]: (state: MaintenanceState) => ({
      ...state,
      maintenanceMode: true,
    }),
    [actions.maintenanceRecovered as any]: (state: MaintenanceState) => ({
      ...state,
      maintenanceMode: false,
    }),
  },
  initialState
);
